// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__iSxK6","log":"ModalInventoryLogs_log__2kbnT","date":"ModalInventoryLogs_date__14buA","userName":"ModalInventoryLogs_userName__3JgIt"};